import { render, staticRenderFns } from "./IconPrinter.vue?vue&type=template&id=309f53ec&scoped=true&"
import script from "./IconPrinter.vue?vue&type=script&lang=js&"
export * from "./IconPrinter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309f53ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('309f53ec')) {
      api.createRecord('309f53ec', component.options)
    } else {
      api.reload('309f53ec', component.options)
    }
    module.hot.accept("./IconPrinter.vue?vue&type=template&id=309f53ec&scoped=true&", function () {
      api.rerender('309f53ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconPrinter.vue"
export default component.exports